import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, Input, Button } from 'antd';
import { isEmpty, isEqual } from 'lodash';

import './SMFormModal.css';

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const phoneRegex = /^\+?[0-9]{6,15}$/;

@inject('translationsStore')
@observer
export default class SMFormModal extends Component {
  constructor(props) {
    super(props);
    this.defaultValues = {
      name: '',
      surname: '',
      companyName: '',
      email: '',
      mobile: '',
      phone: '',
      address: {
        city: '',
        street: '',
        number: ''
      },
      uin: ''
    };
    this.state = this.defaultValues;
  }

  componentDidMount() {
    if (!isEmpty(this.props.data)) {
      this.loadPropData(this.props.data);
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEmpty(this.props.data) && !isEqual(this.props.data, prevProps.data)) {
      this.loadPropData(this.props.data);
    }
  }

  loadPropData = () => {
    let data = this.props.data;
    this.setState(data);
  };

  validateAndSend = () => {
    let isValid = true;

    if(this.state.email && isValid) {
      isValid = isValid && !this.state.isEmailInvalid;
    }
    if(this.state.mobile && isValid) {
      isValid = isValid && !this.state.isMobileInvalid;
    }
    if(this.state.phone && isValid) {
      isValid = isValid && !this.state.isPhoneInvalid;
    }

    if(isValid){
      this.props.onSubmit(this.state);
    }
  };

  checkEmail = email => !!emailRegex.exec(email);

  checkPhone = phone => !!phoneRegex.exec(phone);

  onChangeChecked = fieldName => e =>{
    if(fieldName === 'email'){
      this.checkEmail(e.target.value)? this.setState({isEmailInvalid: false, email : e.target.value}) : this.setState({isEmailInvalid: true, email : e.target.value});
    }
    if(fieldName === 'mobile'){
      this.checkPhone(e.target.value)? this.setState({isMobileInvalid: false, mobile : e.target.value}) : this.setState({isMobileInvalid: true, mobile : e.target.value});
    }
    if(fieldName === 'phone'){
      this.checkPhone(e.target.value)? this.setState({isPhoneInvalid: false, phone : e.target.value}) : this.setState({isPhoneInvalid: true, phone : e.target.value});
    }
  };

  render() {
    const { translationsStore, visible, loading, submitError, submitLabel } = this.props;

    const formPass = {
      name: this.state.name !== '' || this.state.companyName !== '',
      surname: this.state.surname !== '' || this.state.companyName !== '',
      companyName: this.state.name !== '' || this.state.surname !== '' || this.state.companyName !== '',
      email: this.state.email !== '',
      addressCity: this.state.address.city !== '',
      addressStreet: this.state.address.street !== '',
      addressNumber: this.state.address.number !== '',
      uin: this.state.uin.length === 11 || this.state.uin.length === 16
    };

    const canSubmit = Object.values(formPass).reduce((acc, pass) => (pass === false ? false : acc), true);

    return (
      <Fragment>
        {visible && (
          <Modal
            title={translationsStore.translate('serviceManagers.edit.modal.title')}
            visible={visible}
            footer={null}
            onOk={this.props.onOk}
            onCancel={this.props.onCancel}
            width={760}
            className={this.props.className}
          >
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.name')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.name ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderName')}
                  onChange={e => this.setState({ name: e.target.value })}
                  value={this.state.name}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.surname')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.name ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderSurname')}
                  onChange={e => this.setState({ surname: e.target.value })}
                  value={this.state.surname}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.companyName')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.companyName ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderCompanyName')}
                  onChange={e => this.setState({ companyName: e.target.value })}
                  value={this.state.companyName}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.email')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.email ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderEmail')}
                  onChange={this.onChangeChecked('email')}
                  value={this.state.email}
                />
                {this.state.email && this.state.isEmailInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('serviceManagers.form.errorEmailInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.mobile')}</Col>
              <Col span={18}>
                <Input
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderMobile')}
                  onChange={this.onChangeChecked('mobile')}
                  value={this.state.mobile}
                />
                {this.state.mobile && this.state.isMobileInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('serviceManagers.form.errorMobileInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.phone')}</Col>
              <Col span={18}>
                <Input
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderPhone')}
                  onChange={this.onChangeChecked('phone')}
                  value={this.state.phone}
                />
                {this.state.phone && this.state.isPhoneInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('serviceManagers.form.errorPhoneInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.city')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.addressCity ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderCity')}
                  onChange={e => {
                    e.persist();
                    this.setState(prevState => {
                      return {address: {...prevState.address, city: e.target.value}};
                    })
                  }}
                  value={this.state.address.city}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.street')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.addressStreet ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderStreet')}
                  onChange={e => {
                    e.persist();
                    this.setState(prevState => {
                      return {address: {...prevState.address, street: e.target.value}};
                    })
                  }}
                  value={this.state.address.street}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.buildingNumber')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.addressNumber ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderBuildingNumber')}
                  onChange={e => {
                    e.persist();
                    this.setState(prevState => {
                      return {address: {...prevState.address, number: e.target.value}};
                    })
                  }}
                  value={this.state.address.number}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('serviceManagers.form.uin')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.uin ? 'fixme' : ''}
                  placeholder={translationsStore.translate('serviceManagers.form.placeholderUin')}
                  onChange={e => this.setState({ uin: e.target.value })}
                  value={this.state.uin}
                />
              </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {submitError && <div style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>{submitError}</div>}
              <Button type="primary" onClick={this.validateAndSend} disabled={!canSubmit || loading}>
                {submitLabel}
              </Button>
            </div>
          </Modal>
        )}
      </Fragment>
    );
  }
}
